import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AjusteValor } from '../../services/ajuste-valores.service';

@Component({
  selector: 'app-detalle-ajuste-dialog',
  templateUrl: './detalle-ajuste-dialog.component.html',
  styleUrls: ['./detalle-ajuste-dialog.component.scss']
})
export class DetalleAjusteDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    ajuste: AjusteValor,
    conceptoDescripcion: string,
    vendedorNombre: string
  }) { }
}
